<div class="showcase">
  <div class="brandCardImage__container-logo">
    <div
      class="brandCardImage__logo brandCardImage__logo-image brandCardImage__logo-switch"
    >
      BIO
    </div>
    <div
      class="brandCardImage__logo brandCardImage__logo-image brandCardImage__logo-switch brandCardImage__logo-alt"
    >
      BIO
    </div>
  </div>
</div>
<div class="content">
  <div>
    <p class="text">
      Soy Director, Actor, Comediante, Voice Artist y Conferencista. Un Artista
      Multifacético y Empresario, amante de la comedia que ha trabajado por más
      de 15 años en la industria del entretenimiento de Latinoamérica.
    </p>
    <p class="text">
      He sido un creador integral, iniciando con la concepción de las ideas,
      pasando por la escritura del guión y su dirección, hasta llegar a la
      interpretación final de los personajes.
    </p>
    <p class="text">
      Crear, escribir, dirigir, actuar y producir contenidos en distintos
      formatos para llegar a millones de personas a través del entretenimiento y
      la comedia, es mi forma de darle al mundo un poco de maravillas.
    </p>
    <p class="text">
      Poco a poco fui desarrollándome en estas áreas y creando altos estándares
      de calidad que me permiten cumplir mi meta de hacer contenidos que apuntan
      a una proyección mundial.
    </p>
    <p class="text">
      Soy un hombre universal que ama expresarse artísticamente con un lenguaje
      que funcione en todo el planeta, creo en la comedia como el arte más bello
      y siempre sueño con ideas que puedan hacer de este Un Mundo Mejor.
    </p>
    <p class="text">
      <i>¡La vida Brilla si le pones comedia!</i>
    </p>
  </div>
  <div class="foto-bio-1">
    <img src="/assets/Galeria/169-01.jpg" alt="" />
  </div>
  <div class="parrafo-2">
    <div class="sub-title">Mi Visión de Empresa</div>
    <p class="text">
      Partiendo del amor que siento por la comedia y del cariño y admiración que
      tengo por todos los profesionales que se dedican a hacer reír —desde
      cualquier rama del arte—, surgió el sueño de construir un espacio donde la
      comedia pueda existir, crecer, madurar, sostenerse y proyectarse.
    </p>
    <p class="text">
      Así nació Sircomedia Group®, una casa matriz de un conjunto de marcas que
      celebran el don universal de las risas. Un canal para la creación de
      comedia original, y la preservación de genialidades contemporáneas y
      grandes clásicos. Un espacio que sea el soporte y la plataforma de mis
      sueños y los de muchos otros creadores.
    </p>
    <p class="text">
      Con Sircomedia Group® quiero fomentar la cultura y crear una industria
      poderosa de comedia en Latinoamérica, quiero cambiar la historia del
      género en el continente y hacer que el mundo sepa que aquí se sabe hacer
      arte, humor y buenos negocios. Quiero poner a latinoamérica a jugar en las
      grandes ligas con las industrias de comedia más poderosas del mundo; hacer
      que este lado del planeta sea todo un referente mundial de comedia.
    </p>
    <p class="text">
      Este sueño lo creé para que el mundo pueda disfrutar de más y mejores
      artistas de comedia, siempre.
    </p>
  </div>
  <div class="foto-bio-1">
    <img src="/assets/Galeria/169-01.jpg" alt="" />
  </div>
  <div class="parrafo-3">
    <div class="sub-title">Mi visión de Ayuda</div>
    <p class="text">
      Uno de mis sueños es hacer de este Un Mundo Mejor, un lugar donde todos
      podamos ser más felices y más capaces.
    </p>
    <p class="text">
      Dentro de este propósito tengo un interés especial en que los artistas
      puedan llevar a cabo sus creaciones con mayor libertad, y no se vean
      limitados o suprimidos por sus emociones, ni por las presiones económicas
      y sociales que recaen sobre ellos. Quiero sensibilizar acerca de lo que es
      el arte, lo que implica su práctica y los efectos invaluables que causa en
      niños y en toda la sociedad.
    </p>
    <p class="text">
      Esto me ha llevado a hacer algo al respecto, enfocando esfuerzos creativos
      y empresariales en la consolidación de proyectos y marcas destinadas a
      ayudar y educar desde la comedia y el arte. Así nacen Sircomedia Help® y
      Pechos de Héroe®, las cabezas que lideran mi responsabilidad social.
    </p>
    <p class="text">
      Adicionalmente, he tenido la fortuna de conocer causas grandiosas que se
      alinean con mis propósitos de hacer de este un mejor planeta para muchos,
      y que se dedican a ello 24/7. Por eso las apoyo y quiero que muchos las
      conozcan.
    </p>
    <p class="text">Visítalas ⟶</p>
  </div>
  <div class="container-bio-logos">
    <mat-grid-list cols="2" rowHeight="1:0.8" gutterSize="20">
      <mat-grid-tile *ngFor="let image of images; let i = index">
        <a (click)="openWebLogo(image.link)">
          <img [src]="imagesPath + image.src" class="logo-{{ i }}" />
        </a>
      </mat-grid-tile>
    </mat-grid-list>
  </div>
</div>
